var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "category-menu" },
    [
      _c(
        _vm.hideTitleOnMobile ? "common-desktop-element" : "h3",
        {
          tag: "component",
          staticClass: "category-menu__title",
          attrs: { element: "h3" }
        },
        [
          _c("b", { staticClass: "category-menu__title-bold" }, [
            _vm._v("카테고리")
          ]),
          _vm._v("에 따라 강의를 찾아보세요.\n  ")
        ]
      ),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "category-menu__list" },
        [
          _vm._l(_vm.normalCategoryList, function(category) {
            return _c("li", { key: category.id }, [
              _c(
                "a",
                {
                  staticClass: "category-menu__link",
                  attrs: { href: "/" + category.titleLink }
                },
                [
                  category.imgUrl
                    ? _c("common-category-icon", {
                        staticClass: "category-menu__icon",
                        attrs: { src: category.imgUrl, "large-icon": "" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", { staticClass: "category-menu__text" }, [
                    _vm._v(_vm._s(category.title))
                  ])
                ],
                1
              )
            ])
          }),
          _vm._v(" "),
          _vm.showAllCategoryMenu && _vm.allCategoryMenu
            ? _c("common-mobile-element", { attrs: { element: "li" } }, [
                _c(
                  "a",
                  {
                    staticClass: "category-menu__link",
                    attrs: { href: "/" + _vm.allCategoryMenu.titleLink }
                  },
                  [
                    _c("common-category-icon", {
                      staticClass: "category-menu__icon",
                      attrs: {
                        src: _vm.allCategoryMenu.imgUrl,
                        "large-icon": ""
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "category-menu__text" }, [
                      _vm._v("전체보기")
                    ])
                  ],
                  1
                )
              ])
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }